import React from 'react';
import styles from './styles.module.scss';

const ItemElement = ({ item }) => {
  return (
    <div className={`${styles.itemIcon} ${!item?.flag ? styles.hide : ''}`}>
      {item?.flag || (
        <div className={styles.defaultName}>{item?.name?.slice(0, 2)}</div>
      )}
    </div>
  );
};

export default ItemElement;
